<template>
  <div>
    <div id="orderID">
      <b-row>
        <b-col class="mb-1">
          <b-link :to="{ name: 'orders-index' }">
            <feather-icon icon="ArrowLeftIcon" />
            <span class="align-middle ml-50">Back to List</span>
          </b-link>
        </b-col>
      </b-row>
      <b-card>
        <h3>Create New Order</h3>
        <b-row>
          <b-col>
            <validation-observer ref="simpleRules">
              <form ref="form" @submit.stop.prevent="validationEditForm">
                <b-row>
                  <b-col md="4">
                    <b-form-group label="First Name" label-for="firstName">
                      <validation-provider
                        #default="{ errors }"
                        name="firstName"
                        rules="required"
                      >
                        <b-form-input
                          v-on:paste="
                            (e) => {
                              e.preventDefault();
                              return false;
                            }
                          "
                          v-on:keypress="isLetter($event)"
                          id="editname-input"
                          v-model="requetFormData.firstName"
                          :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group label="Last Name" label-for="lastName">
                      <validation-provider
                        #default="{ errors }"
                        name="lastName"
                        rules="required"
                      >
                        <b-form-input
                          v-on:paste="
                            (e) => {
                              e.preventDefault();
                              return false;
                            }
                          "
                          v-on:keypress="isLetter($event)"
                          id="lastName-input"
                          v-model="requetFormData.lastName"
                          :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group label="Email" label-for="email">
                      <validation-provider
                        #default="{ errors }"
                        name="email"
                        rules="required"
                      >
                        <b-form-input
                          v-on:paste="
                            (e) => {
                              e.preventDefault();
                              return false;
                            }
                          "
                          id="email-input"
                          v-model="requetFormData.email"
                          :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group label="Phone Number" label-for="phone">
                      <validation-provider
                        #default="{ errors }"
                        name="phone"
                        rules="required"
                      >
                        <b-form-input
                          id="phone-input"
                          v-model="requetFormData.phone"
                          :state="errors.length > 0 ? false : null"
                          type="number"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group label="Amount" label-for="amount">
                      <validation-provider
                        #default="{ errors }"
                        name="amount"
                        rules="required"
                      >
                        <b-form-input
                          id="amount-input"
                          v-model.number="requetFormData.amount"
                          :state="errors.length > 0 ? false : null"
                          type="number"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group label="Country" label-for="country">
                      <validation-provider
                        #default="{ errors }"
                        name="country"
                        rules="required"
                      >
                        <b-form-select
                          id="country-input"
                          v-model="requetFormData.country"
                          :options="countryOptions"
                          @change="getByCountry"
                          :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group label="Currency" label-for="currency">
                      <validation-provider
                        #default="{ errors }"
                        name="currency"
                        rules="required"
                      >
                        <b-form-select
                          id="currency-input"
                          v-model="requetFormData.currency"
                          :options="currencyOptions"
                          :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group label="City" label-for="city">
                      <validation-provider
                        #default="{ errors }"
                        name="city"
                        rules="required"
                      >
                        <b-form-input
                          v-on:paste="
                            (e) => {
                              e.preventDefault();
                              return false;
                            }
                          "
                          v-on:keypress="isLetter($event)"
                          id="city-input"
                          v-model="requetFormData.city"
                          :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="Payment Option"
                      label-for="paymentOption"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="paymentOption"
                      >
                        <b-form-select
                          id="paymentOption-input"
                          v-model="requetFormData.paymentOptionsId"
                          :options="paymentOptions"
                          :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group
                      v-if="merchantNeedOwnOrderCode"
                      label="Custom OrderCode"
                      label-for="customOrderCode"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Custom OrderCode"
                        rules="required"
                      >
                        <b-form-input
                          id="customOrderCode-input"
                          v-model="requetFormData.customOrderCode"
                          :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-col md="4">
                  <b-button
                    variant="primary"
                    type="submit"
                    @click.prevent="validationForm"
                  >
                    Save
                  </b-button>
                </b-col>
              </form>
            </validation-observer>
          </b-col>
        </b-row>
      </b-card>
    </div>

    <div v-if="toogle">
      <h3>Payment Instructions</h3>
      <br />
      <div>
        <b-row>
          <b-col md="8">
            <b-card>
              <ul class="list-group list-group-flush">
                <li
                  v-for="value in instructions"
                  :key="value"
                  class="list-group-item"
                >
                  <feather-icon color="success" icon="CheckCircleIcon" />
                  {{ value.description }}
                </li>
              </ul>
            </b-card>
          </b-col>

          <b-col md="3">
            <b-card>
              <b-list-group flush>
                <b-list-group-item href="#">
                  Payment Option: <strong>{{ paymentOptionName }}</strong>
                </b-list-group-item>

                <b-list-group-item href="#">
                  Order Id: <strong>{{ orderId }}</strong>
                </b-list-group-item>
                <b-list-group-item href="#">
                  Amount: <strong>{{ returnedAmount }}</strong>
                </b-list-group-item>

                <b-list-group-item href="#">
                  <h3>Expiry date :{{ expiryDate }}</h3>
                </b-list-group-item>
              </b-list-group>
            </b-card>
          </b-col>
        </b-row>
        <b-overlay :show="isLoading" no-wrap rounded="sm" />
      </div>
    </div>
    <b-overlay :show="isLoading" no-wrap rounded="sm" />
  </div>
</template>

<script>
import {
  BCard,
  BButton,
  BOverlay,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BFormSelect,
  BListGroup,
  BListGroupItem,
  BLink,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import axios from "@axios";

export default {
  name: "Users",
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BOverlay,
    BListGroup,
    BListGroupItem,
    BFormGroup,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    BLink,
  },
  data() {
    return {
      required,
      isLoading: false,
      toogle: false,
      instructions: [],
      requetFormData: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        channel: "Mobile",
        amount: "",
        currency: null,
        country: null,
        city: "",
        customOrderCode: "",
        paymentOptionsId: null,
      },
      currencyOptions: [{ value: null, text: "--select a Currency--" }],
      countryOptions: [{ value: null, text: "--select a Country--" }],
      paymentOptions: [{ value: 0, text: "--select PaymentOption--" }],
      statusCheck: "false",
      paymentOptionName: "",
      orderId: "",
      expiryDate: "",
      returnedAmount: null,
      selectedMerchantId: JSON.parse(localStorage.getItem("defaultMerchantId")),
      merchantNeedOwnOrderCode: null,
    };
  },
  computed: {},
  created() {
    this.fetchData();
    this.getDefaultMerchant();
  },

  methods: {
    getDefaultMerchant() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "Merchants-View");

      axios
        .get(
          `/Merchant/api/V1.0/Merchants/GetById?id=${this.selectedMerchantId}`
        )
        .then((res) => {
          this.merchantNeedOwnOrderCode = res.merchant.merchantNeedOwnOrderCode;

          this.isLoading = false;
        })
        .catch((res) => {
          this.isLoading = false;
        });
    },

    getByCountry() {
      this.isLoading = true;
      (this.currencyOptions = [{ value: null, text: "--select a Currency--" }]),
        this.$store.dispatch("config/getActionPrivilege", "Order-Create");
      axios
        .get("/Country/api/V1.0/Country/GetAll")
        .then((res) => {
          res.countries.filter((f) => {
            if (f.countryCode == this.requetFormData.country) {
              f.currencies.forEach((item) => {
                this.currencyOptions.push({
                  value: item.currencyCode,
                  text: item.currencyName,
                });
              });
            }
          });
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },
    isLetter(e) {
      let char = String.fromCharCode(e.charCode || e.which); // Get the character
      if (!/^[a-zA-Z\s]*$/.test(char)) {
        e.preventDefault();
        return false;
      }
      // Match with regex
      // var key = String.fromCharCode(event.charCode || event.which);
      // if (!regex.test(key)) {
      else return true; // If not match, don't add to input text
    },
    isEmailAdd(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          char
        )
      )
        return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    fetchData() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "Order-Create");
      axios
        .get(
          "/PaymentOptions/api/V1.0/PaymentOptions/ViewMerchantPaymentOptions"
        )
        .then((res) => {
          res.paymentOptions.forEach((item) => {
            this.paymentOptions.push({
              value: item.id,
              text: item.name,
            });
          });
          this.isLoading = false;
          this.requetFormData.paymentOptionsId = this.paymentOptions[0].value;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
      axios
        .get("/Country/api/V1.0/Country/GetAll")
        .then((res) => {
          res.countries.forEach((item) => {
            this.countryOptions.push({
              value: item.countryCode,
              text: item.countryName,
            });
          });
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },
    PayByLink() {
      // eslint-disable-next-line no-alert
      alert(`submitted!${this.statusCheck}`);
    },
    validationForm() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          this.$store.dispatch("config/getActionPrivilege", "Order-Create");
          this.isLoading = true;
          axios
            .post("/Order/api/V1.0/Orders/Create", this.requetFormData)
            .then((res) => {
              this.isLoading = false;
              // this.fetchData()

              this.$bvModal.msgBoxOk(`${res.message}`, {
                title: "Success",
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true,
              });
              this.toogle = true;
              this.instructions = res.instractions;
              this.paymentOptionName = res.paymentOptionName;
              this.orderId = res.orderId;
              this.expiryDate = res.expiryDate;
              this.returnedAmount = res.amount;

              document.getElementById("orderID").innerHTML = "";

              // this.$router.push({ name: 'instruction-fop', query: { id: this.requetFormData.paymentOptionsId } })
              // this.router.push({ path: '/orders/Instructions', query: { id: this.requetFormData.paymentOptionsId } })

              //  this.$router.push({ name: 'instruction-fop', query: { id: 9, name: 'PaymentOption' } })
            })
            .catch((res) => {
              console.log(res);
              this.isLoading = false;
              this.$bvModal.msgBoxOk(res.data.message, {
                title: "Error",
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true,
              });
            });

          // eslint-disable-next-line
          //alert('form submitted! '+this.requetFormData.firstName +' '+this.requetFormData.lastName+''+this.requetFormData.country+''+this.requetFormData.city+''+this.requetFormData.amount+''+this.requetFormData.paymentOptionsId+''+this.requetFormData.currency+''+this.requetFormData.phone)
        }
      });
    },
  },
};
</script>
